module.exports = __webpack_public_path__ + "static/favicon-152-3103e276f3d888edd737e26783337546.png";